if (!customElements.get('product-form')) {
  function buildMainCartLineFromForm(form) {
    const formData = new FormData(form);
    const id = parseInt(formData.get('id'), 10);
    if (!id) return null;

    const quantity = Math.max(parseInt(formData.get('quantity') || '1', 10) || 1, 1);
    const line = { id, quantity };
    const propertyPattern = /^properties\[(.+)\]$/;

    for (const key of formData.keys()) {
      const match = propertyPattern.exec(key);
      const value = formData.get(key);
      if (match && value !== '') {
        line.properties = line.properties || {};
        line.properties[match[1]] = value;
      }
    }

    const sellingPlan = formData.get('selling_plan');
    if (sellingPlan) line.selling_plan = sellingPlan;
    return line;
  }

  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      if (this.cart) {
        this.cart.setActiveElement(document.activeElement);
      }

      const cartService = window.Shopify && window.Shopify.cartService;
      const accessoryItems = cartService
        ? cartService.getCustomAddCartItem().concat(cartService.getDefaultItems())
        : [];
      const mainLine = buildMainCartLineFromForm(this.form);
      const useBundledCartAdd = Boolean(mainLine && accessoryItems.length);

      try {
        let fetchResponse;
        if (useBundledCartAdd) {
          const requestBody = { items: [mainLine].concat(accessoryItems) };
          if (this.cart) {
            requestBody.sections = this.cart.getSectionsToRender().map((section) => section.id);
            requestBody.sections_url = window.location.pathname;
          }
          fetchResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(requestBody)
          });
        } else {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
          }
          config.body = formData;
          fetchResponse = await fetch(`${routes.cart_add_url}`, config);
        }

        const response = await fetchResponse.json();
        if (response.status) {
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cart.renderContents(response) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }

        try {
          this.uet_report_conversion(response);
        } catch (trackingError) {
          console.error('Unable to report add-to-cart conversion:', trackingError);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    }

    uet_report_conversion(product) {
      window.uetq = window.uetq || [];
      window.uetq.push(
        'event',
        'add_to_cart',
        {
          "event_label": "add_to_cart_label",
          "revenue_value": product.presentment_price || product.items?.[0]?.presentment_price,
          "currency": "USD"
        }
      );
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
